import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter,
  Output, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';



import { columns } from './columns';
import { PST, PACT } from '../contextual-actions/pim-config';

import { ProcessService } from 'shared/process/process.service';
import { BrandService } from 'shared/brand/brand.service';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ModalHeaderSearchComponent } from 'shared/modal/modal-header-search/modal-header-search.component';
import { ArchivedProductsSearchComponent } from '../archived-products-search/archived-products-search.component';
import { LoaderComponent } from 'shared/loader/loader.component';
import {finalize, takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'view-archived-products-modal',
  templateUrl: 'view-archived-products-modal.component.html',
  styleUrls: ['view-archived-products-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewArchivedProductsModalComponent extends BaseModalComponent {

  @Output() unarchive: EventEmitter<any> = new EventEmitter();
  @Output() deleteAll: EventEmitter<any> = new EventEmitter();

  @ViewChild(ArchivedProductsSearchComponent, {static: false})
  productsSearch: ArchivedProductsSearchComponent | void;

  @ViewChild(ModalHeaderSearchComponent, {static: false})
  headerSearch: ModalHeaderSearchComponent | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  sortingColumns: Array<any> = columns;
  setToDraftAction: any = {
    id: PACT.DRAFT.id,
    action: PACT.DRAFT.name,
    meta: {
      statusId: PST.DRAFT.id
    }
  };

  get selectedProducts(): Array<any> {
    return _.get(this, 'productsSearch.selectedRows', []);
  }

  get isAllSelected(): boolean {
    return _.get(this, 'productsSearch.allSelected', false);
  }

  get isSelectedAllResults(): boolean {
    return _.get(this, 'productsSearch.selectAll', 'on-page') === 'in-list';
  }

  constructor(
    private ref: ChangeDetectorRef,
    private processService: ProcessService,
    private brandService: BrandService,
  ) {
    super();
  }

  onClearClick() {
    if (this.productsSearch) {
      this.productsSearch.searchByTerm('');
    }
  }

  onModalHide() {
    this.hide();
  }

  async onDeleteClick() {
    if (this.loader) {
      this.loader.show();
    }
    const allSelected = _.get(this, 'productsSearch.selectedAllChecked', false) || this.isSelectedAllResults;
    const brandId = this.brandService.getBrand();
    let ids = [];
    const searchModel = _.get(this, 'productsSearch.searchModel', {});
    if (!allSelected) {
      ids = _.map(this.selectedProducts, (item: any) => {
        return _.get(item, '_id.$oid');
      });
    }
    if (allSelected) {
      this.deleteAll.emit({
        searchModel: _.get(this, 'productsSearch.searchModel', {}),
      });
      if (this.loader instanceof LoaderComponent) {
        this.loader.hide();
      }
      this.hide();
    } else {
      this.processService.deleteArchivedItems(
        brandId,
        ids,
        encodeURIComponent(searchModel.searchValue.trim()),
        allSelected
      )
        .pipe(
        finalize(() => this.loader && this.loader.hide()),
        takeWhile(() => this.isModalShown && this.isActive))
        .subscribe(() => {
          if (this.productsSearch) {
        this.productsSearch.reset();
        this.productsSearch.updateSearch();
      }
    });
    }
  }

  onUnarchiveClick() {
    this.unarchive.emit({
      allSelected: _.get(this, 'productsSearch.selectedAllChecked', false) || this.isSelectedAllResults,
      selectedRows: this.selectedProducts,
      totalRecords: _.get(this, 'productsSearch.totalRecords', 0),
      searchModel: _.get(this, 'productsSearch.searchModel', {}),
      action: this.setToDraftAction,
      searchService: _.get(this, 'productsSearch.searchService', {}),
    });
    this.hide();
  }

  show() {
    super.show();
  }

  hide() {
    this.resetData();
    super.hide();
    this.ref.markForCheck();
  }

  resetData(): void {
    if (this.headerSearch) { this.headerSearch.reset(); }
    if (this.productsSearch) { this.productsSearch.reset(); }
  }

  runSearch(searchTerm: string): void {
    if (this.productsSearch) {
      this.productsSearch.searchByTerm(searchTerm);
    }
  }
}
